import Box from '@totallymoney/ui/components/Box'
import Heading from '@totallymoney/ui/components/Heading'
import LinkButton from '@totallymoney/ui/components/LinkButton'
import Stack from '@totallymoney/ui/components/Stack'
import Text from '@totallymoney/ui/components/Text'
import theme from '@totallymoney/ui/theme'
import { SyntheticEvent } from 'react'

import { getAppConfig } from '@utils/getAppConfig'
import { getRedirectAccountUrl } from '@utils/getRedirectAccountUrl'

import { LoanProductCategory } from '@appTypes/LoansApi.interface'

import useAppQueryState from '@hooks/useAppQueryState'
import useLogEvents from '@hooks/useLogEvents'

const NoHomeownerLoansBanner = () => {
    const appConfig = getAppConfig()
    const { appQueryState } = useAppQueryState()
    const logEvents = useLogEvents()

    const urlData = {
        queryObject: {
            category: 'homeowner',
            loanAmount: Number(appQueryState.loanAmount),
            loanTerm: Number(appQueryState.loanTerm),
            client: appConfig.NAME_WHITELABEL,
            loanId: null,
        },
    }

    const redirectAccountUrl = getRedirectAccountUrl(urlData)

    const onCheckEligibilityButtonPress = (
        event: SyntheticEvent<Element, Event>
    ) => {
        event.preventDefault()

        logEvents.logCheckEligibilityEvent({
            category: LoanProductCategory.Secured,
            loanAmount: Number(appQueryState.loanAmount!),
            loanTerm: Number(appQueryState.loanTerm!),
            origin: 'unscored-secured-table',
        })

        window.location.href = redirectAccountUrl
    }

    return (
        <Stack
            space={theme.space30}
            display="flex"
            alignItems="center"
            data-testid="no-homeowner-loans-banner"
        >
            <Stack space={theme.space10}>
                <Heading variant="80" textAlign="center">
                    Secured / Homeowner Loans
                </Heading>
                <Text color="dark" textAlign="center">
                    Before we can show you relevant secured loan offers, we will
                    need to check your eligibility.
                </Text>
            </Stack>
            <Box>
                <LinkButton
                    text="Check my eligibility"
                    variant="primary"
                    href={redirectAccountUrl}
                    onClick={onCheckEligibilityButtonPress}
                />
            </Box>
            <Stack
                space={theme.space20}
                display="flex"
                flexDirection="column"
                alignItems="center"
            >
                <Text variant="100" color="dark">
                    For more information on secured loans, please take a look at
                    our helpful guide below.
                </Text>
                <Text variant="60" color="dark" textAlign="center">
                    <strong>
                        Secured loans: Think carefully before securing other
                        debts against your home. Your home may be repossessed if
                        you don’t keep up repayments on your mortgage or any
                        other debt secured on it
                    </strong>
                </Text>
            </Stack>
        </Stack>
    )
}

export default NoHomeownerLoansBanner
